import { useEffect, useRef, useState } from "react";
import { Formik, Form } from "formik";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { SelectField } from "../../../core/select-field.component";
import { useGetZones } from "../../../apiclient/master/useGetZoneApi";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { useGetDroppingPoint } from "../../../apiclient/party/useGetDropingPointApi";
import { formatDate } from "@progress/kendo-intl";
import axios from "axios";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { API_END_POINT } from "../../../constants";
import { getDataWithToken, getEndPoint } from "../../../Utils/network.client";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useGetMainGroups } from "../../../apiclient/product/useGetMainGroupApi";
import React from "react";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";

export const MonthlyInstitutionBillAbstractReport: React.FC = () => {
  const excelExportRef = useRef<ExcelExport | null>(null);
  /*  const pdfExportRef = useRef<PDFExport | null>(null); */

  const pdfExportRef = React.useRef(null);

  const { data: companyDetails, isLoading: isCompanyLoading } =
    useGetCompanyDetails();
  const companyName = companyDetails?.[0]?.companyName || "Company Name";

  const exportToExcel = () => {
    if (!excelExportRef.current) return;

    const options = excelExportRef.current.workbookOptions();
    const sheet = options.sheets[0];

    const formattedFromDate = fromDate1
      ? new Date(fromDate1).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";

    const formattedToDate = toDate1
      ? new Date(toDate1).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";
    const headingWithDate = `Monthly Wise Institution Bill Abstract - ${formattedFromDate} to ${formattedToDate}`;

    // Add a single merged heading row with the full string
    sheet.rows.unshift({
      cells: [
        {
          value: headingWithDate,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });
    sheet.rows.unshift({
      cells: [
        {
          value: companyName,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    excelExportRef.current.save(options);
  };

  const exportToPDF = () => {
    if (pdfExportRef.current) {
      //pdfExportRef.current;
      const datagrid = pdfExportRef.current;

      // Export all columns, even the hidden ones
      datagrid.save();
    }
  };

  const [fromDate1, setFromDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );

  const [fromDate2, setFromDate2] = useState<string>("");
  const [toDate1, setToDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );

  const [toDate2, setToDate2] = useState<string>("");
  const [gridData, setGridData] = useState([]);
  const [columns, setColumns] = useState([]);

  const initialValues = {
    fDate: fromDate1,
    tdate: toDate1,
  };

  const handlemontlyinstitutionbillabstract = async () => {
    try {
      // Format dates to match API format YYYY-MM-DD
      const formattedFromDate = new Date(fromDate2).toISOString().split("T")[0];
      const formattedToDate = new Date(toDate2).toISOString().split("T")[0];

      const apiUrl = `${getEndPoint(
        API_END_POINT.REPORT
      )}/api/MonthlyReport/GetInstitutionBillAbstract/${fromDate2}/${toDate2}`;

      // Make the API request
      // const response = await axios.get(apiUrl);
      const response = await getDataWithToken<any>(apiUrl);

      if (response.data.jsonstring) {
        const parsedData = JSON.parse(response.data.jsonstring);

        // Extract column headers
        const columnHeaders: string[] = Object.values(
          parsedData.header[0]
        ) as string[];
        const updatedColumns = ["SNo", ...columnHeaders];
        setColumns(updatedColumns);

        // Process details data if available
        if (parsedData.details != null) {
          const transformedData = parsedData.details.map(
            (row: Record<string, any>, index: number) => {
              let newRow: Record<string, any> = { SNo: index + 1 };
              Object.keys(row).forEach((key, index) => {
                newRow[columnHeaders[index]] = row[key];
              });
              return newRow;
            }
          );
          const subtotalRow: Record<string, any> = {};
          columnHeaders.forEach((col) => {
            const total = transformedData.reduce(
              (sum: number, row: { [x: string]: string }) => {
                const value = parseFloat(row[col]);
                return !isNaN(value) ? sum + value : sum;
              },
              0
            );
            subtotalRow[col] =
              isNaN(total) ||
              col == "agentid" ||
              col == "agent " ||
              col == "code"
                ? ""
                : total.toFixed(2);
            // Empty for non-numeric columns
          });

          // Append subtotal row to data
          transformedData.push({ ...subtotalRow, zone: "Total" }); // Add label for subtotal row

          setGridData(transformedData);
        } else {
          console.error("No records available.");
        }
      } else {
        console.error("Invalid response format.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const handleMainGroupChange = (label: any) => {
  //     setMainGroupId(label);
  //     console.log("value")
  // };

  const handleDateChange = (value: any) => {
    // const today = new Date();
    const day = value.getDate().toString().padStart(2, "0");
    const month = value
      .toLocaleString("default", { month: "short" })
      .toUpperCase(); // Get short month (e.g., JAN)
    const year = value.getFullYear();

    const formattedDate = new Date(`${year}-${month}-${day}`);

    setFromDate(formattedDate);

    // const formattedDate2 = dayjs(value).format('ddd MMM DD YYYY');
    // console.log(formattedDate2);
    // setToDate(formattedDate2);
  };

  const handleDateChanges = (value: any) => {
    // const today = new Date();
    const day = value.getDate().toString().padStart(2, "0");
    const month = value
      .toLocaleString("default", { month: "short" })
      .toUpperCase(); // Get short month (e.g., JAN)
    const year = value.getFullYear();

    const formattedDate2 = new Date(`${year}-${month}-${day}`);

    setToDate(formattedDate2);

    // const formattedDate2 = dayjs(value).format('ddd MMM DD YYYY');
    // console.log(formattedDate2);
    // setToDate(formattedDate2);
  };
  useEffect(() => {
    if (fromDate1) {
      const formattedDate1 = dayjs(fromDate1).format("ddd MMM DD YYYY ");
      // console.log("Formatted Date:", formattedDate1);
      setFromDate2(formattedDate1);
    }
    if (toDate1) {
      const formattedDate2 = dayjs(toDate1).format("ddd MMM DD YYYY ");
      // console.log("Formatted Date:", formattedDate2);
      setToDate2(formattedDate2);
    }
  }, [fromDate1, toDate1]);
  const hasRecords = gridData.length > 0;

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log("Form submitted with values: ", values);
      }}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <div
            className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
            style={{ minHeight: "500px" }}
          >
            <div className="top-sec-align row">
              <center>
                <h4 className="text-normal title-web mb-0 report-title-color">
                  Monthly Wise Institution Bill Abstract
                </h4>
              </center>
            </div>
            <div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
              {/* <div>
                <label>Search</label>
                <input
                  type="text"
                  className="form-control ms-auto search-right-align searchBg"
                />
              </div> */}

              <div className="d-flex">
                <div className="me-2">
                  <label>From Date</label>
                  <DatePicker
                    selectsMultiple={true}
                    openToDate={new Date()}
                    className="form-control ms-auto search-right-align calendarBg"
                    value={formatDate(fromDate1, "dd/MM/yyyy")}
                    placeholderText="From"
                    dateFormat={"dd/MM/yyyy"}
                    onChange={([date]: any) => {
                      setFromDate(date);
                      handleDateChange(date);
                    }}
                  />
                </div>
                <div className="me-2">
                  <label>To Date</label>
                  <DatePicker
                    selectsMultiple={true}
                    openToDate={new Date()}
                    className="form-control ms-auto search-right-align calendarBg"
                    value={formatDate(toDate1, "dd/MM/yyyy")}
                    placeholderText="To"
                    dateFormat={"dd/MM/yyyy"}
                    onChange={([date]: any) => {
                      setToDate(date);
                      handleDateChanges(date);
                    }}
                  />
                </div>

                <div>
                  <label></label>
                  <button
                    className="btn-primary btn search-btns mt-4"
                    type="submit"
                    onClick={() => {
                      handlemontlyinstitutionbillabstract();
                    }}
                  >
                    <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                      <path
                        id="Path_magnify"
                        data-name="Path / magnify"
                        d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                        transform="translate(-3 -3)"
                        fill="#fff"
                      />
                    </svg>
                  </button>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToExcel}
                    disabled={!hasRecords}
                    style={{ marginTop: "23px", marginBottom: "2px" }}
                  >
                    Export to Excel
                  </button>
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToPDF}
                    disabled={!hasRecords}
                    style={{ marginTop: "23px", marginBottom: "2px" }}
                  >
                    Export to PDF
                  </button>
                </div>
              </div>
            </div>
            {/* <div className="row col=12"> */}
            <div>
              <PDFExport
                ref={pdfExportRef}
                fileName="Monthly Institution Bill Abstract.pdf"
              >
                <div style={{ padding: "10px", backgroundColor: "#fff" }}>
                  {/* Company Name */}
                  <div style={{ textAlign: "center", marginBottom: "5px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                      {companyDetails?.[0]?.companyName || "Company Name"}
                    </span>
                  </div>
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      Monthly Wise Institution Bill Abstract
                      {fromDate1 && toDate1 && (
                        <>
                          {" - "}
                          {new Date(fromDate1).toLocaleDateString("en-IN", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          })}{" "}
                          to{" "}
                          {new Date(toDate1).toLocaleDateString("en-IN", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          })}
                        </>
                      )}
                    </span>
                  </div>

                  {gridData.length > 0 && columns.length > 0 ? (
                    // <Grid data={gridData} style={{ height: "auto" }}>
                    //   {columns.map((col, index) => (
                    //     <GridColumn key={index} field={col} title={col}  className={index > 2 ? "text-end" : ""} />
                    //   ))}
                    // </Grid>
                    <Grid data={gridData} style={{ height: "auto" }}>
                      <GridColumn
                        field="SNo"
                        title="S.No"
                        width="60px"
                        className={"text-center"}
                      />
                      <GridColumn field="code" title="CODE" width="60px" />
                      <GridColumn field="agent " title="AGENT" width="250px" />
                      {columns
                        .filter(
                          (col) =>
                            col !== "SNo" &&
                            col !== "code" &&
                            col !== "agentid" &&
                            col !== "agent "
                        )
                        .map((col, index) => {
                          const title = col; // Assuming title is the same as the field name for simplicity
                          // Calculate width based on title length
                          const calculatedWidth = `${Math.max(
                            100,
                            title.length * 11
                          )}px`; // Example calculation
                          return (
                            <GridColumn
                              key={index}
                              field={col}
                              title={col}
                              width={calculatedWidth}
                              className={"text-end"}
                            />
                          );
                        })}
                    </Grid>
                  ) : (
                    <p>No data Found</p>
                  )}
                </div>
              </PDFExport>

              <ExcelExport
                data={gridData}
                ref={excelExportRef}
                fileName="Monthly Institution Bill Abstract.xlsx"
              >
                {columns
                  .filter((col) => col !== "blockid" && col !== "routeid") // Exclude blockid and routeid columns
                  .map((col, index) => (
                    <ExcelExportColumn key={index} field={col} title={col} />
                  ))}
              </ExcelExport>

              {/* {gridData.length > 0 && columns.length > 0 ? (
                <Grid data={[...gridData]} style={{ height: "400px" }}>
                  {columns.map((col, index) => (
                    <GridColumn
                      key={index}
                      field={col}
                      title={col}
                      className={index > 2 ? "text-end" : ""}
                      headerClassName={index > 2 ? "text-end" : ""}
                    // footerCell={() => {
                    //   const total = columnTotals(col);
                    //   return !isNaN(total) ? <strong>{total.toFixed(2)}</strong> : null;
                    // }}                
                    />
                  ))}
                </Grid>
              ) : null} */}
            </div>
            {/* </div> */}
          </div>
        </Form>
      )}
    </Formik>
  );
};
